function mkRefreshDrawer() {
  return fetch('/?sections=cart-drawer-section')
    .then(function (r) { return r.json(); })
    .then(function (s) {
      var doc = new DOMParser().parseFromString(s['cart-drawer-section'], 'text/html');
      var fresh = doc.querySelector('.cart-drawer__inner');
      var cur = document.querySelector('.cart-drawer__inner');
      if (!fresh || !cur) throw new Error('no drawer');
      cur.replaceWith(fresh);
    });
}

document.addEventListener('click', function (e) {
  var btn = e.target.closest('[data-mk-upsell-add]');
  if (!btn || btn.disabled) return;
  btn.disabled = true;
  btn.textContent = '...';
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: [{ id: parseInt(btn.dataset.variantId, 10), quantity: 1 }] })
  })
    .then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
    .then(mkRefreshDrawer)
    .catch(function () { location.reload(); });
});

// Selector de packs: agrega al carrito y abre el carrito lateral (en vez de ir a /cart)
document.addEventListener('click', function (e) {
  var btn = e.target.closest('.mk-bundles .mk-add');
  if (!btn) return;
  var drawer = document.querySelector('theme-drawer#cart-drawer');
  if (!drawer || typeof drawer.open !== 'function') return;
  e.preventDefault();
  e.stopImmediatePropagation();
  if (btn.disabled) return;
  var root = btn.closest('.mk-bundles');
  var checked = root.querySelector('input[type="radio"]:checked');
  var qty = parseInt(checked ? checked.value : '1', 10);
  var msg = root.querySelector('.mk-msg');
  btn.disabled = true;
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: [{ id: parseInt(root.dataset.variantId, 10), quantity: qty }] })
  })
    .then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
    .then(function (cart) {
      return mkRefreshDrawer().then(function () {
        document.querySelectorAll('.cart-count-bubble, [data-cart-count], .header-actions__cart-count').forEach(function (el) { el.textContent = cart.item_count; });
        btn.disabled = false;
        document.querySelector('theme-drawer#cart-drawer').open();
      });
    })
    .catch(function () {
      if (msg) msg.textContent = 'No pudimos agregar el producto. Probá de nuevo.';
      btn.disabled = false;
    });
}, true);

document.addEventListener('scroll', function (e) {
  var t = e.target;
  if (!t || !t.matches || !t.matches('[data-mk-track]')) return;
  var dots = t.parentNode.querySelectorAll('[data-mk-dots] i');
  var i = Math.round(t.scrollLeft / t.clientWidth);
  dots.forEach(function (d, n) { d.classList.toggle('on', n === i); });
}, true);

// Tarjetas de producto: si la segunda imagen es un video, se reproduce (x1.2).
// Computadora: mientras el mouse esta encima. Celular: mientras se mantiene el dedo apoyado.
// Los videos se precargan para que arranquen al instante.
(function () {
  var RATE = 1.2;
  var HOLD_MS = 220;
  var canHover = !!(window.matchMedia && matchMedia('(hover: hover)').matches);
  var cache = {};
  var current = null;
  var held = null;
  var holdTimer = 0;
  var suppressClick = false;

  // Evita el menu/vista previa del sistema y la seleccion al mantener el dedo apoyado
  var st = document.createElement('style');
  st.textContent = '.card-gallery{-webkit-touch-callout:none;-webkit-user-select:none;user-select:none;-webkit-tap-highlight-color:transparent}.card-gallery a,.card-gallery img{-webkit-touch-callout:none;-webkit-user-drag:none}';
  document.head.appendChild(st);

  function getVideoSrc(handle) {
    if (cache[handle]) return cache[handle];
    cache[handle] = fetch('/products/' + handle + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        var m = p && p.media && p.media[1];
        if (!m || m.media_type !== 'video' || !m.sources) return null;
        var mp4 = m.sources.filter(function (s) { return s.format === 'mp4' || /mp4/.test(s.mime_type || ''); });
        if (!mp4.length) return null;
        mp4.sort(function (a, b) { return a.height - b.height; });
        var pick = mp4.filter(function (s) { return s.height >= 480; })[0] || mp4[mp4.length - 1];
        return pick.url;
      })
      .catch(function () { return null; });
    return cache[handle];
  }

  function handleOf(g) {
    var a = g.querySelector('a[href*="/products/"]');
    var m = a && a.getAttribute('href').match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  function prepare(g) {
    if (g.__mkv) return g.__mkv;
    var h = handleOf(g);
    if (!h) return Promise.resolve(null);
    g.__mkv = getVideoSrc(h).then(function (src) {
      if (!src) return null;
      var v = document.createElement('video');
      v.className = 'mk-hover-video';
      v.src = src;
      v.muted = true; v.loop = true; v.playsInline = true; v.preload = 'auto';
      v.defaultPlaybackRate = RATE; v.playbackRate = RATE;
      v.setAttribute('muted', ''); v.setAttribute('playsinline', '');
      v.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;object-fit:cover;z-index:1;pointer-events:none;opacity:0;background:#000';
      g.appendChild(v);
      return v;
    });
    return g.__mkv;
  }

  function play(g, stillActive) {
    prepare(g).then(function (v) {
      if (!v || !stillActive()) return;
      v.playbackRate = RATE;
      var p = v.play();
      v.style.opacity = '1';
      if (p && p.catch) p.catch(function () { v.style.opacity = '0'; });
    });
  }

  function stop(g) {
    var v = g.querySelector('video.mk-hover-video');
    if (!v) return;
    v.pause();
    v.style.opacity = '0';
    try { v.currentTime = 0; } catch (err) {}
  }

  function warm() {
    var conn = navigator.connection;
    if (conn && conn.saveData) return;
    var cards = document.querySelectorAll('.card-gallery');
    var max = canHover ? 12 : 4;
    for (var i = 0; i < cards.length && i < max; i++) prepare(cards[i]);
  }
  if (document.readyState === 'complete') setTimeout(warm, 800);
  else window.addEventListener('load', function () { setTimeout(warm, 800); });

  // Computadora (mouse)
  document.addEventListener('pointerover', function (e) {
    if (e.pointerType === 'touch') return;
    var g = e.target.closest && e.target.closest('.card-gallery');
    if (!g || g === current) return;
    if (current) stop(current);
    current = g;
    play(g, function () { return current === g; });
  });

  document.addEventListener('pointerout', function (e) {
    if (e.pointerType === 'touch' || !current) return;
    var to = e.relatedTarget;
    if (to && current.contains(to)) return;
    stop(current);
    current = null;
  });

  // Celular (dedo apoyado)
  function release() {
    clearTimeout(holdTimer);
    holdTimer = 0;
    if (held) {
      stop(held);
      held = null;
      setTimeout(function () { suppressClick = false; }, 450);
    }
  }

  document.addEventListener('pointerdown', function (e) {
    if (e.pointerType !== 'touch') return;
    var g = e.target.closest && e.target.closest('.card-gallery');
    if (!g) return;
    prepare(g);
    clearTimeout(holdTimer);
    holdTimer = setTimeout(function () {
      held = g;
      suppressClick = true;
      play(g, function () { return held === g; });
    }, HOLD_MS);
  }, { passive: true });

  document.addEventListener('pointerup', release, true);
  document.addEventListener('pointercancel', release, true);
  document.addEventListener('scroll', function () { if (held || holdTimer) release(); }, true);

  document.addEventListener('click', function (e) {
    if (!suppressClick) return;
    if (e.target.closest && e.target.closest('.card-gallery')) {
      e.preventDefault();
      e.stopPropagation();
    }
  }, true);

  document.addEventListener('contextmenu', function (e) {
    if (!canHover && e.target.closest && e.target.closest('.card-gallery')) e.preventDefault();
  });
})();
